import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhotoViewerService, PhotoViewerData } from '../services/photo-viewer.service';
import { MaterialModule } from 'src/app/material.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';

@Component({
    selector: 'app-photo-viewer',
    standalone: true,
    imports: [CommonModule, MaterialModule, HttpClientModule],
    templateUrl: './photo-viewer.component.html',
    styleUrls: ['./photo-viewer.component.scss']
})
export class PhotoViewerComponent implements OnInit {

    photos: string[] = [];
    downloadPhotos: string[] = [];
    currentIndex = 0;
    zoomLevel = 1;
    title = 'Photo Viewer';

    private readonly ZOOM_STEP = 0.25;
    private readonly ZOOM_MIN = 0.5;
    private readonly ZOOM_MAX = 3;

    constructor(
        private photoService: PhotoViewerService,
        private http: HttpClient
    ) { }

    ngOnInit(): void {
        const data = this.photoService.getPhotos();
        this.photos = data.photos;
        this.downloadPhotos = data.downloadPhotos;
        this.currentIndex = data.startIndex;
        this.title = data.title || 'Photo Viewer';
        document.title = this.title;
    }

    get currentPhoto(): string {
        return this.photos[this.currentIndex] || '';
    }

    get counter(): string {
        return `${this.currentIndex + 1} / ${this.photos.length}`;
    }

    nextPhoto(): void {
        this.zoomLevel = 1;
        this.currentIndex = (this.currentIndex + 1) % this.photos.length;
    }

    prevPhoto(): void {
        this.zoomLevel = 1;
        this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length;
    }

    zoomIn(): void {
        this.zoomLevel = Math.min(this.ZOOM_MAX, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
    }

    zoomOut(): void {
        this.zoomLevel = Math.max(this.ZOOM_MIN, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
    }

    onWheel(event: WheelEvent): void {
        event.preventDefault();
        event.deltaY < 0 ? this.zoomIn() : this.zoomOut();
    }

    download(): void {
        if (!this.currentPhoto) return;

        const downloadUrl = this.downloadPhotos[this.currentIndex] || this.currentPhoto;

        this.http.get(downloadUrl, { responseType: 'blob' }).subscribe({
            next: (blob) => {
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `photo_${this.currentIndex + 1}.jpg`;
                link.click();
                URL.revokeObjectURL(url);
            },
            error: () => {
                this.http.get(this.currentPhoto, { responseType: 'blob' }).subscribe({
                    next: (blob) => {
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = `photo_${this.currentIndex + 1}.jpg`;
                        link.click();
                        URL.revokeObjectURL(url);
                    },
                    error: () => {
                        window.open(this.currentPhoto, '_blank');
                    }
                });
            }
        });
    }

    close(): void {
        this.photoService.clear();
        window.close();
    }

    @HostListener('window:keydown', ['$event'])
    onKeydown(event: KeyboardEvent): void {
        switch (event.key) {
            case 'ArrowRight': this.nextPhoto(); break;
            case 'ArrowLeft': this.prevPhoto(); break;
            case '+':
            case '=': this.zoomIn(); break;
            case '-': this.zoomOut(); break;
            case 'Escape': this.close(); break;
        }
    }
}